import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../../components';
import { InteractiveButton } from '../../../../../components';

interface ModalScholarShipProps {
  handleClick: () => void;
  hasScholarship?: boolean;
}
const ModalScholarShip: React.FC<ModalScholarShipProps> = (props) => {
  const { handleClick, hasScholarship } = props;
  return (
    <>
      <Block
        customized
        maxWidth={isMobile ? '100%' : '496px'}
        backgroundColor="#fff"
        padding="0px 32px 32px 32px"
        margin="8px 0px 0px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Heading
          text={
            hasScholarship
              ? ''
              : 'Actualmente, estás matriculado en un solo curso.'
          }
          level={2}
          color="#161D1F"
          size={20}
          lineHeight={32}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
        {hasScholarship ? (
          <p
            style={{
              textAlign: 'center',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px'
            }}
          >
            Para nuestros estudiantes Becados, los invitamos a realizar Retiro
            de <br /> asignaturas - Becarios Pronabec
          </p>
        ) : (
          <p
            style={{
              textAlign: 'center',
              alignItems: 'center',
              marginTop: 12
            }}
          >
            Para retirarte de todos los cursos, debes <br /> realizar Retiro de
            periodo lectivo
          </p>
        )}

        <InteractiveButton
          data-testid="handle-SAE"
          bkgColorEnabled="#5B36F2"
          bkgColorHover="#745EF6"
          bkgColorFocus="#4318CD"
          bkgColorPressed="#4318CD"
          customized
          as="button"
          alignItems="center"
          backgroundColor="#5B36F2"
          padding="10px 16px"
          borderRadius="4px"
          margin="40px 0px 0px 0px"
          width={isMobile ? '100%' : '180px'}
          onClick={() => handleClick()}
        >
          <Text
            color="#FFFFFF"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="400"
            textAlign="center"
          >
            Ir a solicitudes de SAE
          </Text>
        </InteractiveButton>
      </Block>
    </>
  );
};

export default ModalScholarShip;
